import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "src/modules/notification";
import {
  checkSnAssignAvailability,
  resetSNAvailabilityList,
} from "src/modules/companies/redux";
import SnAvailabilityListTableComponent from "./snAvailabilityListTable.component";

function SnAvailabilityListTableContainer({
  handleReload,
  format,
  activeType,
  formik,
  selectedProduct,
}) {
  const dispatch = useDispatch();
  const snAvailabilityList = useSelector(
    (state) => state.companies.snAvailabilityList.data
  );
  const isError = useSelector(
    (state) => state.companies.snAvailabilityList.isError
  );
  const isLoading = useSelector((state) =>
    selectLoading(state, checkSnAssignAvailability.typePrefix)
  );

  useEffect(
    () => () => {
      dispatch(resetSNAvailabilityList());
    },
    [dispatch]
  );

  useEffect(() => {
    if (snAvailabilityList.length) {
      // Only count quantity for available items (not skipped/same product)
      const totalQty = snAvailabilityList.reduce((total, sn) => {
        const isSkipped =
          selectedProduct &&
          sn.product &&
          sn.product.id === selectedProduct.product_uuid;
        return total + (isSkipped ? 0 : sn.quantity);
      }, 0);
      formik.setFieldValue("quantity", totalQty);
    }
  }, [snAvailabilityList, selectedProduct]);

  return (
    <SnAvailabilityListTableComponent
      isLoading={isLoading}
      error={isError}
      list={snAvailabilityList}
      handleReload={handleReload}
      format={format}
      activeType={activeType}
      formik={formik}
      selectedProduct={selectedProduct}
    />
  );
}

export default SnAvailabilityListTableContainer;
